import base from '@/__vue2stone/service/wasaapi/v1/__base';
import moment from 'moment';
import store from '@/store';
import i18n from '@/i18n';
import popupListData from '@/spare/dashboard-popuplist-data';

export default {
  async create(factoryId, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.create({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'event',
      data: _data,
    });
    return res;
  },
  async update(eventId, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.update({
      modelName: 'event',
      modelId: eventId,
      data: _data,
    });
    return res;
  },
  async show(eventId, params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.show({
      modelName: 'event',
      modelId: eventId,
      params: _params,
    });
    return res;
  },
  async delete(eventId, params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.delete({
      modelName: 'event',
      modelId: eventId,
      params: _params,
    });
    return res;
  },
  async eventCurrentAddIndex(factoryId, params, type = 'factory') {
    //取得record內容
    const currentFactory = store.state.app.factory;
    let _params = {};
    _params = {
      factory: currentFactory.id,
      ...params,
    };
    if (type === 'organization') {
      _params = {
        ..._params,
        organization: currentFactory.id,
      };
      delete _params.factory;
    }
    const res = await base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'event/current_add',
      params: _params,
      pagination: true,
    });
    return res;
  },
  async eventIndex(factoryId, params, type = 'factory') {
    //取得record內容
    const currentFactory = store.state.app.factory;
    let _params = {};
    _params = {
      factory: currentFactory.id,
      ...params,
    };
    if (type === 'organization') {
      _params = {
        ..._params,
        organization: currentFactory.id,
      };
      delete _params.factory;
    }
    const res = await base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'event',
      params: _params,
      pagination: true,
    });
    return res;
  },
  async eventAllIndex(params, type = 'factory') {
    //board calendar
    const currentFactory = store.state.app.factory;
    let _params = {};
    _params = {
      factory: currentFactory.id,
      get_all: 1,
      ...params,
    };
    if (type === 'organization') {
      _params = {
        organization: currentFactory.id,
        ..._params,
      };
    }
    const res = await base.index({
      parentName: 'factory',
      parentId: currentFactory.id,
      modelName: 'event',
      params: _params,
      pagination: false,
    });
    return res;
  },
  async eventAllIndexV2(params) {
    const currentFactoryId = store.state.app.factory.id;
    let _params = {};
    _params = {
      factory: currentFactoryId,
      get_all: 1,
      ...params,
    };
    const res = await base.index({
      parentName: 'factory',
      parentId: currentFactoryId,
      modelName: 'event/board/index',
      params: _params,
      pagination: false,
    });
    return res;
  },
  async eventPrintIndex(params, type = 'factory') {
    //取得record內容
    const currentFactory = store.state.app.factory;
    let _params = {};
    _params = {
      factory: currentFactory.id,
      ...params,
    };
    if (type === 'organization') {
      _params = {
        organization: currentFactory.id,
        ..._params,
      };
    }
    const res = await base.index({
      parentName: 'factory',
      parentId: currentFactory.id,
      modelName: 'event_print/index',
      params: _params,
      pagination: true,
    });
    return res;
  },
  getEventAddRowData(factoryId, list) {
    if (!list || list.length === 0) return [];
    const _list = list.map((item) => {
      return {
        id: item.id,
        name: item.name,
        status: {
          color:
            item.event_status === 1
              ? 'yellow'
              : item.event_status === 2
              ? 'red'
              : item.event_status === 3
              ? 'gray'
              : 'yellow',
          text:
            item.event_status === 1
              ? i18n.t('處理中')
              : item.event_status === 2
              ? i18n.t('列管中')
              : item.event_status === 3
              ? i18n.t('處理完畢')
              : i18n.t('處理中'),
        },
        date: moment(item.occur_at).format('HH:mm'),
        owner: item.owner,
        icon: {
          icon: 'icon-arrow-right',
          path: `/factory/${factoryId}/event-content/${item.id}`,
        },
      };
    });
    return _list;
  },
  getEventTotalRowData(factoryId, list) {
    if (!list || list.length === 0) return [];
    const _list = list.map((item) => {
      return {
        id: item.id,
        name: item.name,
        status: {
          color: 'yellow',
          text: '處理中',
        },
        date: moment(item.occur_at).format('YYYY-MM-DD HH:mm:ss'),
        owner: item.owner ? item.owner : { name: '', avatar: '' },
        icon: {
          icon: 'icon-arrow-right',
          path: `/factory/${factoryId}/event-content/${item.id}`,
        },
      };
    });
    return _list;
  },
  getEventCurrentAddPopupContent(factory, data) {
    return {
      title: `${factory.name}` + '-本日新增風險事件',
      button: {
        text: '前往列表',
        to: `/factory/${factory.id}/events`,
      },
      columnHeader: popupListData.eventAddColumHeader,
      rowData: this.getEventAddRowData(factory.id, data),
    };
  },
};
